// Production OWOLOVO wordmark (white artwork on transparent bg).
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/099bmrk6_logoooo-3.png";

// inverse=true → keep white (for dark backgrounds); inverse=false → invert to black (light bg).
export const Logo = ({ inverse = false, height = 24, className = "" }) => {
  return (
    <img
      src={LOGO_URL}
      alt="OWOLOVO"
      draggable={false}
      style={{ height }}
      className={`w-auto select-none ${inverse ? "" : "invert"} ${className}`}
    />
  );
};
